import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const labelKey = 'products.glasses.offering.includesLenses';
const IncludesLensesLink = ({ tabIndex  })=>{
    const { getFormattedLabel , hasLabel  } = useIntl();
    const includesLensesLink = React.useMemo(()=>{
        if (!hasLabel(labelKey)) {
            return null;
        }
        const formattedLabel = getFormattedLabel(labelKey, {
            parseLink: true,
            parseHTML: true,
            hideLabelKey: true
        });
        if (!/*#__PURE__*/ React.isValidElement(formattedLabel)) {
            return formattedLabel;
        }
        return /*#__PURE__*/ React.cloneElement(formattedLabel, {
            tabIndex
        });
    }, [
        getFormattedLabel,
        hasLabel,
        tabIndex
    ]);
    return /*#__PURE__*/ React.createElement(Text, {
        className: "product-block__bottom-link"
    }, includesLensesLink);
};

export { IncludesLensesLink };
//# sourceMappingURL=IncludesLensesLink.js.map
